export const changeHistoryTypes = {
  userCreation: "USER_CREATION",
  userDeletion: "USER_DELETION",
  userChange: "USER_CHANGE",
  userPasswordReset: "USER_PASSWORD_RESET"
};
